"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-96cea41e"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "すべて選択", -1 /* HOISTED */));
const _hoisted_2 = { class: "oplus-gray-text" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "コピー", -1 /* HOISTED */));
const _hoisted_4 = { class: "oplus-gray-text" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "切り取り", -1 /* HOISTED */));
const _hoisted_6 = { class: "oplus-gray-text" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "貼り付け", -1 /* HOISTED */));
const _hoisted_8 = { class: "oplus-gray-text" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "終了", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-gray-text" }, "Esc", -1 /* HOISTED */));
const _hoisted_11 = [
    _hoisted_9,
    _hoisted_10
];
const vue_3 = require("vue");
const tableEditMode_1 = require("../tableEditMode");
const osType_1 = require("../enums/osType");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CellEditMenu',
    props: {
        osType: {
            type: String,
            required: true,
        }
    },
    emits: ["edit-menu-ref"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const editMenuRef = (0, vue_3.ref)(null);
        const emit = __emit;
        function handleSelectAllClick() {
            (0, tableEditMode_1.handleSelectAll)();
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleCopyClick() {
            (0, tableEditMode_1.handleCellCopyOrCut)(true);
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleCutClick() {
            (0, tableEditMode_1.handleCellCopyOrCut)(false);
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handlePasteClick() {
            (0, tableEditMode_1.handleCellPaste)();
            tableEditMode_1.cellEditMode.isMenuVisible = false;
        }
        function handleExitClick() {
            (0, tableEditMode_1.destroyCellEdit)();
        }
        const shortcutText = (0, vue_3.computed)(() => {
            let iconText = "";
            switch (props.osType) {
                case osType_1.OSType.MAC:
                    iconText = "⌘";
                    break;
                case osType_1.OSType.WINDOWS:
                    iconText = "Ctrl";
                    break;
            }
            // will implement android/ios in another task
            return iconText;
        });
        (0, vue_3.onMounted)(() => {
            emit('edit-menu-ref', editMenuRef);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref_key: "editMenuRef",
                ref: editMenuRef,
                class: "cell-edit-menu-wrapper"
            }, [
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleSelectAllClick
                }, [
                    _hoisted_1,
                    (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)(shortcutText.value) + " A", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleCopyClick
                }, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(shortcutText.value) + " C", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleCutClick
                }, [
                    _hoisted_5,
                    (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(shortcutText.value) + " X", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handlePasteClick
                }, [
                    _hoisted_7,
                    (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)(shortcutText.value) + " V", 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-item",
                    onClick: handleExitClick
                }, _hoisted_11)
            ], 512 /* NEED_PATCH */));
        };
    }
});
